import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../../config.js";

const Lead = () => {
  const [records, setRecords] = useState([]);
  const [filterText, setFilterText] = useState("");

  /* ---------------- FETCH APPROVAL LIST ---------------- */
  useEffect(() => {
    fetchApprovalList();
  }, []);

  const fetchApprovalList = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.get(`${API_BASE_URL}/approval-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      setRecords(res.data.records);
    } catch (err) {
      console.error("Failed to load approval list:", err);
    }
  };

  /* ---------------- SEARCH FILTER ---------------- */
  const filteredItems = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.incharge_name} ${item.hod_name} ${item.hr_status}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  /* ---------------- DATATABLE COLUMNS ---------------- */
  const columns = [
    {
      name: "Employee ID",
      selector: (row) => row.employee_id,
      sortable: true,
      width: "130px",
    },
    {
      name: "Employee",
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={row.profile_picture}
            alt="profile"
            width="40"
            height="40"
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
          <span>{row.employee_name}</span>
        </div>
      ),
    },
    {
      name: "Incharge Name",
      selector: (row) => row.incharge_name,
      sortable: true,
    },
    {
      name: "HOD Name",
      selector: (row) => row.hod_name,
      sortable: true,
    },
    {
      name: "HR Status",
      selector: (row) => row.hr_status,
      sortable: true,
      cell: (row) => (
        <span
          className={`badge ${
            row.hr_status === "HR" ? "bg-success" : "bg-secondary"
          }`}
        >
          {row.hr_status || "Pending"}
        </span>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        {/* HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0">All Approval List</h6>

          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search..."
            style={{ width: "220px" }}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>

        {/* TABLE */}
        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredItems}
            pagination
            highlightOnHover
            striped
            responsive
            paginationPerPage={25}
            paginationRowsPerPageOptions={[25, 50, 100]}
          />
        </div>
      </div>
    </div>
  );
};

export default Lead;
